import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getOrderGeneratorsFieldsWorksMaterials(companyId, generatorId) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS].getOrderGeneratorsFieldsWorksMaterials,
		{
			urlParams: {
				companyId,
        generatorId,
			},
		}
	)
}

function getOrderGeneratorsFieldsWorksMaterial(companyId, generatorId, materialId) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS].getOrderGeneratorsFieldsWorksMaterial,
		{
			urlParams: {
				companyId,
        generatorId,
				materialId,
			},
		}
	)
}

function createOrderGeneratorsFieldsWorksMaterial(companyId, generatorId, payload) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS].createOrderGeneratorsFieldsWorksMaterial,
		{
			urlParams: {
				companyId,
        generatorId,
			},
			...payload,
		}
	)
}


function putOrderGeneratorsFieldsWorksMaterial(companyId, generatorId, materialId, payload) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS].putOrderGeneratorsFieldsWorksMaterial,
		{
			urlParams: {
				companyId,
        generatorId,
				materialId,
			},
			...payload,
		}
	)
}

function patchOrderGeneratorsFieldsWorksMaterial(companyId, generatorId, materialId, payload) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS].patchOrderGeneratorsFieldsWorksMaterial,
		{
			urlParams: {
				companyId,
        generatorId,
				materialId,
			},
			...payload,
		}
	)
}

function deleteOrderGeneratorsFieldsWorksMaterial(companyId, generatorId, materialId) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS].deleteOrderGeneratorsFieldsWorksMaterial,
		{
			urlParams: {
				companyId,
        generatorId,
				materialId,
			},
		}
	)
}

export default {
	getOrderGeneratorsFieldsWorksMaterials,
	getOrderGeneratorsFieldsWorksMaterial,
	createOrderGeneratorsFieldsWorksMaterial,
	putOrderGeneratorsFieldsWorksMaterial,
	patchOrderGeneratorsFieldsWorksMaterial,
	deleteOrderGeneratorsFieldsWorksMaterial,
}

